module.exports = __webpack_public_path__ + "media/page-7_alt.17db01cb.mp3";